import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { BehaviorSubject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class CompanyService {
  baseUrl: string = environment.API_SERVER;
  structureEvent: BehaviorSubject<any> = new BehaviorSubject<any>(null);
  emitEvent(event: any) {
    console.log(event, 'event');
    this.structureEvent.next(event);
  }
  getEvent() {
    return this.structureEvent.asObservable();
  }
  constructor(private _http: HttpClient) {}
  getCompanyEquipment(payload) {
    return this._http.get(
      `${this.baseUrl}/organization/${payload.organizationId}/eqipments/`,
      {
        params: payload.params,
      }
    );
  }
  deleteRequestDocument(payload) {
    return this._http.patch(
      `${this.baseUrl}/change-request/discard/${payload.id}`,
      payload.body
    );
  }
  getRequestDocument(payload) {
    return this._http.get(
      this.baseUrl +
        `/change-request/get-documents/${payload.changeRequestType}/`
    );
  }

  getCompanyEquipmentByStatus(payload) {
    return this._http.get(
      `${this.baseUrl}/organization/${payload.organizationId}/eqipments_by_status/?status=${payload.status}`,
      {
        params: payload.params,
      }
    );
  }

  updateEquipment(payload) {
    return this._http.put(
      `${this.baseUrl}/organization/${payload.organizationId}/eqipments/${payload.equipmentId}/status/${payload.status}/`,
      payload.body
    );
  }
  deleteEquipment(payload) {
    return this._http.delete(
      `${this.baseUrl}/organization/${payload.organizationId}/eqipment/${payload.equipmentId}`
    );
  }
  downloadEquipmentTemplate(payload) {
    return this._http.get(
      `${this.baseUrl}/organization/${payload.organizationId}/eqipment-upload-template/?toFileName=${payload.fileName}`
    );
  }

  uploadEquipmentTemplate(payload) {
    return this._http.post(
      `${this.baseUrl}/organization/${payload.organizationId}/eqipment-upload-data/`,
      payload.body
    );
  }

  getCountries(payload) {
    const params = new HttpParams()
      .set('sidx', 'countryName')
      .set('sord', 'asc')
      .set('rows', '3000')
      .set('page', '1')
      .set('_search', 'true');
    return this._http.get(this.baseUrl + '/public/countries/', {
      params: params,
    });
  }

  getStates(payload) {
    const params = new HttpParams()
      .set('sidx', 'stateName')
      .set('sord', 'asc')
      .set('rows', '3000')
      .set('page', '1')
      .set('_search', 'true')
      .set('filters', payload.filter);
    console.log(params);
    return this._http.get(this.baseUrl + '/public/states/', { params: params });
  }
  getOptions(payload) {
    const params = new HttpParams()
      .set('sidx', 'optionId')
      .set('sord', 'desc')
      .set('rows', '3000')
      .set('page', '1')
      .set('_search', 'true')
      .set('filters', payload.filter);
    return this._http.get(this.baseUrl + '/public/options/', {
      params: params,
    });
  }
  addCompanyEquipment(payload) {
    return this._http.post(
      `${this.baseUrl}/organization/${payload.organizationId}/eqipment/`,
      payload.body
    );
  }
  getCompanyTCC(payload) {
    return this._http.get(
      `${this.baseUrl}/organization/${payload.organizationId}/tcc/${payload.tccNumber}/`
    );
  }
  updateCompanyEquipment(payload) {
    return this._http.put(
      `${this.baseUrl}/organization/${payload.organizationId}/eqipment/${payload.id}/`,
      payload.body
    );
  }
  removeCompanyEquipment(payload) {
    return this._http.delete(
      `${this.baseUrl}/organization/${payload.organizationId}/eqipment/${payload.id}/`
    );
  }

  //Director/Shareholders

  getCompanyDirector(payload) {
    return this._http.get(
      `${this.baseUrl}/organization/${payload.organizationId}/ownerships/${payload.ownershipType}/by-type/`,
      {
        params: payload.params,
      }
    );
  }
  addCompanyDirector(payload) {
    return this._http.post(
      `${this.baseUrl}/organization/${payload.organizationId}/ownership/`,
      payload.body
    );
  }
  updateCompanyDirector(payload) {
    return this._http.put(
      `${this.baseUrl}/organization/${payload.organizationId}/ownership/${payload.id}/`,
      payload.body
    );
  }
  removeCompanyDirector(payload) {
    return this._http.delete(
      `${this.baseUrl}/organization/${payload.organizationId}/ownership/${payload.id}/`
    );
  }

  //OtherTccRecord
  getOtherTccRecords(payload) {
    return this._http.get(
      `${this.baseUrl}/organization/tcc/other/?organizationId=${payload.organizationId}`,
      {
        params: payload.params,
      }
    );
  }

  addOtherTccRecords(payload) {
    return this._http.post(
      `${this.baseUrl}/organization/tcc/other/`,
      payload.body
    );
  }

  //CompanyTccRecord
  getCompanyTcc(payload) {
    return this._http.get(
      `${this.baseUrl}/organization/${payload.organizationId}/tccs/`,
      {
        params: payload.params,
      }
    );
  }

  addCompanyTcc(payload) {
    return this._http.post(
      `${this.baseUrl}/organization/${payload.organizationId}/tcc/${payload.tccNumber}/`,
      payload.body
    );
  }
  updateCompanyTcc(payload) {
    return this._http.put(
      `${this.baseUrl}/organization/${payload.organizationId}/tcc/${payload.id}/`,
      payload.body
    );
  }
  removeCompanyTcc(payload) {
    return this._http.delete(
      `${this.baseUrl}/organization/${payload.organizationId}/tcc/${payload.id}/`
    );
  }

  //CompanyRecord
  getCompanyTccRecord(payload) {
    return this._http.get(
      `${this.baseUrl}/organization/${payload.organizationId}/tcc/${payload.tccId}/records/`,
      {
        params: payload.params,
      }
    );
  }
  addCompanyTccRecord(payload) {
    return this._http.post(
      `${this.baseUrl}/organization/${payload.organizationId}/tcc/${payload.tccId}/records/`,
      payload.body
    );
  }
  updateCompanyTccRecord(payload) {
    return this._http.put(
      `${this.baseUrl}/organization/${payload.organizationId}/tcc/${payload.tccId}/record/${payload.id}/`,
      payload.body
    );
  }
  removeCompanyTccRecord(payload) {
    return this._http.delete(
      `${this.baseUrl}/organization/${payload.organizationId}/tcc/${payload.tccId}/record/${payload.id}/`
    );
  }

  getRequestHistory(payload) {
    return this._http.get(
      `${this.baseUrl}/change-request/type/${payload.changeRequestType}/history/?organizationId=${payload.organizationId}`,
      {
        params: payload.params,
      }
    );
  }

  getPendingHistory(payload) {
    return this._http.get(`${this.baseUrl}/change-request/pending/`, {
      params: payload.params,
    });
  }

  getSavedChangeRequest(payload) {
    return this._http.get(
      `${this.baseUrl}/change-request/saved?changeRequestType=${payload.changeRequestType}`
    );
  }
  deleteSavedChangeRequest(payload) {
    return this._http.delete(
      `${this.baseUrl}/change-request/saved?changeRequestType=${payload.changeRequestType}`
    );
  }
}
